import Vue from 'vue';
import bugsnag from '@bugsnag/js';
import bugsnagVue from '@bugsnag/plugin-vue';
import { version } from '../package.json';

let bugSnagClientInstance;
const initializeBugSnagClient = () => {
  if (bugSnagClientInstance) {
    return bugSnagClientInstance;
  }
  if (process.env.VUE_APP_RELEASE_STAGE === 'test') {
    bugSnagClientInstance = {
      notify: (error) => { console.log(`test = ${JSON.stringify(error)}`); },
    };
  } else {
    bugSnagClientInstance = bugsnag({
      apiKey: 'a349fcc93e0d835243f7a92f8b200ad5',
      releaseStage: process.env.VUE_APP_RELEASE_STAGE,
      // eslint-disable-next-line no-undef
      appVersion: version,
      // notifyReleaseStages: ['staging', 'production'],
    });
    bugSnagClientInstance.use(bugsnagVue, Vue);
  }
  return bugSnagClientInstance;
};
const bugsnagClient = initializeBugSnagClient();
export default bugsnagClient;
